import callGetFunction from './call-function-with-authenticated-user';
import { GET_SIGNED_SIGMA_EMBEDS } from './functions-path';

export default async (params) => {
  const sigmaResult = await callGetFunction(GET_SIGNED_SIGMA_EMBEDS, params);
  return sigmaResult.result;
};
